module.exports = __webpack_public_path__ + "img/66.8f3b2f12.jpg";